// extracted by mini-css-extract-plugin
module.exports = {"spacesGrid":"AssetSectionSpaceCategories_spacesGrid__VyYm2","spacesItem":"AssetSectionSpaceCategories_spacesItem__Sw2ob"};